import React from 'react';
import { FILE_UPLOAD_STATES } from '../../constants';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import { LinearProgress } from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { formatBytes } from 'react-dropzone-uploader';
import { getImageURLBasedOnMimeType } from '../../utils';
import { getFormattedString } from '../../../../utils';
import useStyles from './styles';
import RemoveButton from '../../components/removeButton/RemoveButton';
import Button from '@material-ui/core/Button';
import ErrorIcon from '../../../../assets/error-icon.png';
import AvatarWrapper from '../../../AvatarWrapper/AvatarWrapper';

const AvatarPreview = props => {
  const {
    meta,
    fileWithMeta: { restart },
  } = props;
  const { name, percent, status, previewUrl, type, size } = meta || {};
  const classes = useStyles();

  const isDone = status === FILE_UPLOAD_STATES.DONE;
  const isError = status === FILE_UPLOAD_STATES.FAILED || status === FILE_UPLOAD_STATES.FILE_SIZe;
  const canRetry = isError && status !== FILE_UPLOAD_STATES.FILE_SIZe;
  const imageURL = isError ? ErrorIcon : getImageURLBasedOnMimeType(type, previewUrl);
  const formattedName = getFormattedString(name, 25);

  const handleRemove = () => {
    const { fileWithMeta } = props;
    fileWithMeta.remove();
  };

  const handleRestart = () => restart();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        <CardContent className={classes.contentRoot}>
          {imageURL ? (
            <AvatarWrapper
              alt={name}
              className={classes.avatar}
              imageUrl={imageURL}
              name={name}
              servedFromWebpack={isError}
            />
          ) : null}
          <Typography
            align="center"
            className={classes.uploadTitle}
            variant="caption">{`${formattedName} | ${formatBytes(size)}`}</Typography>
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.actions}>
        <RemoveButton onRemoveHandler={handleRemove} />
        {canRetry ? (
          <Button color="primary" onClick={handleRestart} variant="contained">
            Retry
          </Button>
        ) : null}
      </CardActions>
      {!isDone ? <LinearProgress value={percent} variant="determinate" /> : null}
    </Card>
  );
};

export default AvatarPreview;
